<template>
    <div class="product-showcase-feature-wrapper section-space--pt_120">
        <div class="container">
            <div class="row">
                <div class="col-lg-4">
                    <div class="section-title-wrapper section-space--mb_60 wow move-up">
                        <h3 class="font-weight--light text-primary">{{ sectionTitle }}</h3>
                    </div>
                </div>
                <div class="col-lg-8 wow move-up mtn-30">
                    <div v-for="(feature, index) in productFeature" :key="index" class="ht-product-service-box mt-30 px-3">
                        <div class="content-header">
                            <div class="icon">
                                <i :class="feature.icon"></i>
                            </div>
                            <h6 class="heading">{{ feature.title }}</h6>
                        </div>
                        <div class="content-body">
                            <div class="service_text" v-html="feature.desc "></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ProductShowcase',
        data() {
            return {
                sectionTitle: 'Vantaggi dell\'innovazione',
                productFeature: [{
                        icon: 'fal fa-recycle',
                        title: 'Completa automazione dei processi',
                        desc: '• Automazione della preparazione e cottura delle pietanze<br/>• Automazione del confezionamento vassoi<br/>• Automazione del lavaggio delle stoviglie<br/>• Costanza del prodotto finale<br/>• Riduzione dell’errore umano'
                    },
                    {
                        icon: 'fal fa-people-carry',
                        title: 'Flessibilità dei processi',
                        desc: '• Composizione del vassoio personalizzato senza operatori<br/>• Drastica riduzione dei tempi di riattivazione delle pietanze<br/>• Perfezione del lavaggio mediante l\impiego degli ultrasuoni<br/>• Completa eliminazione delle stoviglie in plastica<br/>• Possibilità di aumentare le pietanze calde all\interno del vassoio',
                    },
                ]
            }
        }
    };
</script>